import { render, staticRenderFns } from "./Cholesterol.vue?vue&type=template&id=07e2fc2c"
import script from "./Cholesterol.vue?vue&type=script&lang=js"
export * from "./Cholesterol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports